(function () {
    'use strict';
    var m = angular.module('common');
    m.controller('urlReputationWhitelistLinksModalController', ["$q", "$scope", "$modalInstance", "$timeout", "options", "modals", "urlReputationDao", function ($q, $scope, $modalInstance, $timeout, options, modals, urlReputationDao) {
        $scope.loading = true;
        $scope.loaded = false;
        $scope.entity_type = options.entityType;
        $scope.entity_id = options.entityId;
        $scope.whitelist = [];
        $scope.urls = [];
        function getTrimedLink(link) {
            if (link.startsWith('http://')) {
                link = link.substring(7);
            }
            if (link.startsWith('https://')) {
                link = link.substring(8);
            }
            if (link.startsWith('www.')) {
                link = link.substring(4);
            }
            link = link.split('?')[0];
            link = link.split('/')[0];
            return link;
        }
        function initLinks() {
            $scope.loading = true;
            $scope.loaded = false;
            $scope.urls = [];
            var added_links = [];
            urlReputationDao.getWhitelistUrls().then(function (response) {
                $scope.loading = false;
                $scope.loaded = true;
                $scope.whitelist = response.data;
                _(options.links).map(function (url) {
                    url.link = getTrimedLink(url.link);
                    if (url.classification == 'Benign') {
                        return;
                    }
                    if ($scope.whitelist.includes(url.link)) {
                        url.toWhitelist = true;
                    }
                    if (!added_links.includes(url.link)) {
                        added_links.push(url.link);
                        $scope.urls.push(url);
                    }
                });
            });
        }
        initLinks();
        $scope.close = function () {
            $modalInstance.dismiss();
        };
        $scope.ok = function () {
            var remove_urls = [];
            var add_urls = [];
            _($scope.urls).map(function (url) {
                if (url.toWhitelist) {
                    add_urls.push(url.link);
                } else {
                    remove_urls.push(url.link);
                }
            });
            urlReputationDao.updateWhitelistUrls(add_urls, remove_urls).then(function (response) {
                $modalInstance.dismiss();
            });
        };    // function getWhitelistedUrls() {
              //     return urlReputationDao.getWhitelistUrls().then(function(response){
              //         $scope.current_urls = response.data;
              //     });
              // }
              // getWhitelistedUrls();
    }]);
    m.factory('urlReputationWhitelistLinksModalRun', ["$modal", "path", "feature", "$rootScope", function ($modal, path, feature, $rootScope) {
        return {
            show: function (options) {
                var instance = $modal.open({
                    templateUrl: path('gui-v2').ctrl('url-reputation-whitelist-links-modal').template(),
                    size: 'lg',
                    controller: 'urlReputationWhitelistLinksModalController',
                    windowClass: 'url-reputation-whitelist-modal',
                    resolve: { options: _.constant(options) }
                });
                return instance.result;
            }
        };
    }]);
}());